import React, { PropsWithChildren, ReactNode } from 'react';
import { ModalContainer, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { ErrorRender } from 'src/shared/ui/error';

export interface ModalErrorBoundaryProps extends PropsWithChildren {
  fallbackAction?: ReactNode;
}
export class ModalErrorBoundary extends React.Component<ModalErrorBoundaryProps, { error: Error | null }> {
  constructor(props: ModalErrorBoundaryProps) {
    super(props);
    this.state = { error: null };
    ErrorRender.register('yh-error');
  }

  render() {
    if (this.state.error) {
      return (
        <ModalLayout>
          <ModalContainer>
            {/* @ts-expect-error custom element */}
            <yh-error error={this.state.error}></yh-error>
          </ModalContainer>
        </ModalLayout>
      );
    }
    return this.props.children;
  }

  componentDidCatch() {
    //
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }
}
